import { forwardRef, type Ref, type SVGProps } from "react";
const IconLinkFilledSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path d="M17.76 21.56a7.43 7.43 0 0 1-5.26-2.18 2 2 0 1 1 2.83-2.83 3.53 3.53 0 0 0 4.87 0l4.67-4.67A3.44 3.44 0 1 0 20 7l-1.92 1.93a2 2 0 0 1-2.83-2.82l1.92-1.93A7.45 7.45 0 1 1 27.7 14.71L23 19.38a7.44 7.44 0 0 1-5.24 2.18" />
    <path d="M9.32 30a7.45 7.45 0 0 1-5.26-12.71l4.67-4.67a7.46 7.46 0 0 1 10.53 0 2 2 0 0 1-2.83 2.83 3.53 3.53 0 0 0-4.87 0l-4.67 4.67A3.44 3.44 0 0 0 11.76 25l1.92-1.92a2 2 0 0 1 2.83 2.82l-1.92 1.93A7.44 7.44 0 0 1 9.32 30" />
  </svg>
);
const ForwardRef = forwardRef(IconLinkFilledSVG);
ForwardRef.displayName = "IconLinkFilled";
export { ForwardRef as IconLinkFilled };
